(function () {
  if (window.sgDesktopProductLayoutV9Loaded) return;

  window.sgDesktopProductLayoutV9Loaded = true;

  var desktopQuery =
    window.matchMedia('(min-width: 990px)');

  var remembered = new Map();

  var detailsColumn = null;
  var observer = null;
  var timer = null;
  var busy = false;


  function remember(element) {
    if (
      !element ||
      remembered.has(element) ||
      !element.parentNode
    ) {
      return;
    }

    var marker =
      document.createComment(
        'sg-original-position'
      );

    element.parentNode.insertBefore(
      marker,
      element
    );

    remembered.set(
      element,
      marker
    );
  }


  function restore(element) {
    var marker =
      remembered.get(element);

    if (
      marker &&
      marker.parentNode
    ) {
      marker.parentNode.insertBefore(
        element,
        marker.nextSibling
      );
    }
  }


  function sectionFor(selector) {
    var element =
      document.querySelector(selector);

    return element
      ? element.closest('.shopify-section')
      : null;
  }


  function move(element, parent) {
    if (!element || !parent) return;

    remember(element);

    if (element.parentNode !== parent) {
      parent.appendChild(element);
    }
  }


  function getProductArea() {
    return document.querySelector(
      '[data-testid="product-information"]'
    );
  }


  function getProductGrid(productArea) {
    return productArea
      ? productArea.querySelector(
          'product-component.product-information__grid'
        )
      : null;
  }


  function getBuyButtons(productArea) {
    return (
      document.querySelector(
        '#sg-desktop-product-details > .buy-buttons-block'
      ) ||
      (
        productArea &&
        productArea.querySelector(
          '.buy-buttons-block'
        )
      )
    );
  }


  function ensureDetailsColumn(productGrid) {
    if (
      detailsColumn &&
      detailsColumn.isConnected &&
      detailsColumn.parentNode === productGrid
    ) {
      return detailsColumn;
    }

    detailsColumn =
      document.createElement('div');

    detailsColumn.id =
      'sg-desktop-product-details';

    detailsColumn.className =
      'product-details sg-desktop-product-details';

    productGrid.appendChild(
      detailsColumn
    );

    return detailsColumn;
  }


  function applyDesktopLayout() {
    if (!desktopQuery.matches || busy) return;

    busy = true;

    var productArea =
      getProductArea();

    var productGrid =
      getProductGrid(productArea);

    var buyButtons =
      getBuyButtons(productArea);

    var titlePrice =
      sectionFor('.sg-title-price');

    var deals =
      sectionFor('.sg-deals');

    var delivery =
      sectionFor('.sg-delivery-card');

    if (
      !productArea ||
      !productGrid ||
      !buyButtons ||
      !titlePrice ||
      !deals ||
      !delivery
    ) {
      busy = false;
      return;
    }

    productArea.classList.add(
      'sg-desktop-layout-active'
    );

    var details =
      ensureDetailsColumn(productGrid);

    move(
      titlePrice,
      details
    );

    move(
      buyButtons,
      details
    );

    move(
      deals,
      details
    );

    move(
      delivery,
      details
    );

    var wishlistSource =
      document.querySelector(
        '[id$="__178379843855379919"]'
      );

    var shareSource =
      document.querySelector(
        '[id$="__custom_liquid_NnYHeU"]'
      );

    if (wishlistSource) {
      wishlistSource.classList.add(
        'sg-desktop-helper-source'
      );
    }

    if (shareSource) {
  shareSource.classList.add(
    'sg-desktop-helper-source'
  );
}

if (observer) {
  observer.disconnect();
  observer = null;
}

busy = false;
  }


  function restoreMobileLayout() {
    if (desktopQuery.matches || busy) return;

    busy = true;

    remembered.forEach(
      function (_, element) {
        restore(element);
      }
    );

    document
      .querySelectorAll(
        '.sg-desktop-helper-source'
      )
      .forEach(function (element) {
        element.classList.remove(
          'sg-desktop-helper-source'
        );
      });

    var productArea =
      document.querySelector(
        '.sg-desktop-layout-active'
      );

    if (productArea) {
      productArea.classList.remove(
        'sg-desktop-layout-active'
      );
    }

    if (
      detailsColumn &&
      detailsColumn.parentNode
    ) {
      detailsColumn.remove();
    }

    detailsColumn = null;

    busy = false;
  }


  function applyLayout() {
    if (desktopQuery.matches) {
      applyDesktopLayout();
    } else {
      restoreMobileLayout();
    }
  }


  function scheduleLayout() {
    clearTimeout(timer);

    timer =
      setTimeout(
        applyLayout,
        100
      );
  }


  function start() {
    applyLayout();

    setTimeout(applyLayout, 300);
    setTimeout(applyLayout, 900);
    setTimeout(applyLayout, 1800);

    var root =
      document.querySelector('main') ||
      document.body;

    observer =
      new MutationObserver(
        scheduleLayout
      );

    observer.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener(
        'change',
        applyLayout
      );
    } else {
      desktopQuery.addListener(
        applyLayout
      );
    }

    document.addEventListener(
      'shopify:section:load',
      scheduleLayout
    );
  }


  if (document.readyState === 'complete') {
  start();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    start,
    { once: true }
  );
}
})();

(function () {
  if (window.sgProductErrorPopupLoaded) return;
  window.sgProductErrorPopupLoaded = true;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var popup = document.getElementById("sg-error-popup");
    var popupText = document.getElementById("sg-error-popup-text");
    var closeBtn = popup ? popup.querySelector(".sg-error-popup__close") : null;

    if (!popup || !popupText) return;

    var allowPopup = false;

    function cleanMessage(message) {
      message = (message || "").replace(/\s+/g, " ").trim();

      if (/maximum quantity/i.test(message)) {
        return "You’ve already added the maximum available quantity to your bag.";
      }

      if (/sold out/i.test(message)) {
        return "This item is currently sold out.";
      }

      return message || "Unable to add this item to your bag.";
    }

    function getNativeErrorMessage() {
      var selectors = [
        "main .product-form__error-message",
        "main .product-form__error-message-wrapper"
      ];

      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);

        if (el && el.textContent.trim()) {
          return cleanMessage(el.textContent);
        }
      }

      return "";
    }

    function showPopup(message) {
      popupText.textContent = cleanMessage(message);
      popup.classList.add("is-active");
      popup.setAttribute("aria-hidden", "false");
    }

    function hidePopup() {
      popup.classList.remove("is-active");
      popup.setAttribute("aria-hidden", "true");
    }

    function checkForError() {
      if (!allowPopup) return;

      var msg = getNativeErrorMessage();

      if (msg) {
        showPopup(msg);
        allowPopup = false;
      }
    }

    document.addEventListener("click", function (event) {
      var addBtn = event.target.closest(
        'main button[data-testid="standalone-add-to-cart"]'
      );

      if (addBtn) {
        allowPopup = true;

        setTimeout(checkForError, 150);
        setTimeout(checkForError, 500);
        setTimeout(checkForError, 1000);
        setTimeout(checkForError, 1600);
      }
    });

    var main = document.querySelector("main");

    if (main) {
      var observer = new MutationObserver(function () {
        checkForError();
      });

      observer.observe(main, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    }

    if (closeBtn) closeBtn.addEventListener("click", hidePopup);

    popup.addEventListener("click", function (event) {
      if (event.target === popup) hidePopup();
    });
  });
})();

(function () {
  if (window.sgSoldOutShiprocketFixLoaded) return;
  window.sgSoldOutShiprocketFixLoaded = true;

  function getAddToBagButton() {
    return document.querySelector(
      'main button[data-testid="standalone-add-to-cart"]'
    );
  }

  function selectedVariantIsSoldOut() {
    var button = getAddToBagButton();

    if (!button) return false;

    var buttonText = (
      button.textContent || ''
    )
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    return (
      buttonText.includes('sold out') ||
      buttonText.includes('unavailable') ||
      buttonText.includes('out of stock')
    );
  }

  function updateSoldOutLayout() {
    document.body.classList.toggle(
      'sg-product-is-sold-out',
      selectedVariantIsSoldOut()
    );
  }

  function initialiseSoldOutFix() {
    updateSoldOutLayout();

    /*
     * Recheck after Shopify and Shiprocket finish
     * loading and after a customer changes variants.
     */
    setTimeout(updateSoldOutLayout, 200);
    setTimeout(updateSoldOutLayout, 600);
    setTimeout(updateSoldOutLayout, 1200);
    setTimeout(updateSoldOutLayout, 2500);

    document.addEventListener(
      'change',
      function () {
        setTimeout(updateSoldOutLayout, 50);
        setTimeout(updateSoldOutLayout, 300);
        setTimeout(updateSoldOutLayout, 800);
      },
      true
    );

    document.addEventListener(
      'input',
      function () {
        setTimeout(updateSoldOutLayout, 100);
      },
      true
    );

    var main = document.querySelector('main');

    if (main) {
      var observer = new MutationObserver(function () {
        updateSoldOutLayout();
      });

      observer.observe(main, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          'disabled',
          'aria-disabled',
          'class'
        ]
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseSoldOutFix
    );
  } else {
    initialiseSoldOutFix();
  }
})();

(function () {
  if (window.sgWishlistShareRowLoaded) return;
  window.sgWishlistShareRowLoaded = true;

  var shareSlot =
    document.querySelector('.sg-share-slot');

  if (!shareSlot) return;

  var shareSlotId = shareSlot.id;
  var actionsKey =
    shareSlot.dataset.actionsKey;

    /*
      Finite retries give the wishlist app time
      to render its product-page button.
    */
    var retryDelays = [
      0,
      200,
      500,
      900,
      1500,
      2500,
      4000,
      6000
    ];

    function getShareSlot() {
      return document.getElementById(
        shareSlotId
      );
    }

    function getProductScope(element) {
      if (!element) {
        return document;
      }

      return (
        element.closest(
          [
            '[data-testid="product-information"]',
            '.product-information',
            '.product__info-container',
            '.product-info',
            'main'
          ].join(',')
        ) || document
      );
    }

    function findDealsHeader(shareSlot) {
      var productScope =
        getProductScope(shareSlot);

      return (
        productScope.querySelector(
          '[data-sg-deals] .sg-deals__header'
        ) ||
        document.querySelector(
          '[data-sg-deals] .sg-deals__header'
        )
      );
    }

    function findWishlistWrapper(shareSlot) {
      var productScope =
        getProductScope(shareSlot);

      return (
        productScope.querySelector(
          '.Vtl-WishlistButtonWrapper'
        ) ||
        document.querySelector(
          '.Vtl-WishlistButtonWrapper'
        )
      );
    }

    function getCleanProductUrl() {
      try {
        var productUrl = new URL(
          window.location.href
        );

        productUrl.hash = '';

        productUrl.searchParams.delete(
          'preview_theme_id'
        );

        productUrl.searchParams.delete(
          'preview_token'
        );

        productUrl.searchParams.delete(
          'refresh'
        );

        return productUrl.toString();
      } catch (error) {
        return window.location.href.split(
          '#'
        )[0];
      }
    }

    function showShareToast(toast) {
      if (!toast) {
        return;
      }

      toast.classList.add(
        'is-visible'
      );

      window.setTimeout(
        function () {
          toast.classList.remove(
            'is-visible'
          );
        },
        2000
      );
    }

    function fallbackCopy(url) {
      var textArea =
        document.createElement(
          'textarea'
        );

      textArea.value = url;
      textArea.setAttribute(
        'readonly',
        ''
      );

      textArea.style.position = 'fixed';
      textArea.style.top = '-9999px';
      textArea.style.left = '-9999px';
      textArea.style.opacity = '0';

      document.body.appendChild(
        textArea
      );

      textArea.focus();
      textArea.select();

      try {
        document.execCommand(
          'copy'
        );
      } catch (error) {
        /* Native sharing remains the primary method. */
      }

      textArea.remove();
    }

    function copyProductLink(
      url,
      toast
    ) {
      if (
        navigator.clipboard &&
        navigator.clipboard.writeText
      ) {
        navigator.clipboard
          .writeText(url)
          .then(function () {
            showShareToast(toast);
          })
          .catch(function () {
            fallbackCopy(url);
            showShareToast(toast);
          });

        return;
      }

      fallbackCopy(url);
      showShareToast(toast);
    }

    function bindShareButton() {
      var slot = getShareSlot();

      if (!slot) {
        return false;
      }

      var button = slot.querySelector(
        '.sg-share-button'
      );

      var toast = slot.querySelector(
        '.sg-share-toast'
      );

      if (!button) {
        return false;
      }

      if (
        button.dataset.shareBound ===
        'true'
      ) {
        return true;
      }

      button.dataset.shareBound =
        'true';

      button.addEventListener(
        'click',
        function () {
          var title =
            slot.dataset.productTitle ||
            document.title;

          var url =
            getCleanProductUrl();

          if (navigator.share) {
            navigator
              .share({
                title: title,
                text:
                  'Check out this product from Sperkygem',
                url: url
              })
              .catch(function (error) {
                if (
                  error.name !==
                  'AbortError'
                ) {
                  copyProductLink(
                    url,
                    toast
                  );
                }
              });

            return;
          }

          copyProductLink(
            url,
            toast
          );
        }
      );

      return true;
    }

    /*
      Returns:
      true  = product is in the wishlist
      false = product is not in the wishlist
      null  = app is currently rebuilding and its
              state cannot be safely determined
    */
    function getWishlistState(wrapper) {
      if (!wrapper) {
        return null;
      }

      var stateElement =
        wrapper.querySelector(
          [
            '[aria-pressed]',
            '[aria-selected]',
            '[data-added]',
            '[data-wishlist-added]',
            '[data-selected]'
          ].join(',')
        );

      if (stateElement) {
        var attributes = [
          'aria-pressed',
          'aria-selected',
          'data-added',
          'data-wishlist-added',
          'data-selected'
        ];

        for (
          var index = 0;
          index < attributes.length;
          index += 1
        ) {
          var attributeValue =
            stateElement.getAttribute(
              attributes[index]
            );

          if (
            attributeValue === 'true'
          ) {
            return true;
          }

          if (
            attributeValue === 'false'
          ) {
            return false;
          }
        }
      }

      var normalisedText = (
        wrapper.textContent || ''
      )
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (
        normalisedText.indexOf(
          'remove from wishlist'
        ) !== -1 ||
        normalisedText.indexOf(
          'remove wishlist'
        ) !== -1 ||
        normalisedText.indexOf(
          'added to wishlist'
        ) !== -1 ||
        normalisedText.indexOf(
          'in wishlist'
        ) !== -1
      ) {
        return true;
      }

      if (
        normalisedText.indexOf(
          'add to wishlist'
        ) !== -1 ||
        normalisedText.indexOf(
          'add to wish list'
        ) !== -1
      ) {
        return false;
      }

      return null;
    }

    function getWishlistClickable(
      wrapper
    ) {
      if (!wrapper) {
        return null;
      }

      return wrapper.querySelector(
        [
          'button',
          '[role="button"]',
          '.Vtl-WishlistButton > div',
          '.Vtl-WishlistButton'
        ].join(',')
      );
    }

    function applyWishlistVisualState(
      wrapper,
      isAdded
    ) {
      if (!wrapper) {
        return;
      }

      wrapper.classList.toggle(
        'sg-wishlist-is-added',
        Boolean(isAdded)
      );

      var clickable =
        getWishlistClickable(
          wrapper
        );

      if (!clickable) {
        return;
      }

      var label = isAdded
        ? 'Remove from wishlist'
        : 'Add to wishlist';

      clickable.setAttribute(
        'aria-label',
        label
      );

      clickable.setAttribute(
        'title',
        label
      );
    }

    function syncWishlistState(
      wrapper
    ) {
      var detectedState =
        getWishlistState(wrapper);

      /*
        Do not change the visible icon while the
        app temporarily has no readable state.
      */
      if (detectedState === null) {
        return;
      }

      applyWishlistVisualState(
        wrapper,
        detectedState
      );
    }

    function scheduleWishlistChecks(
      wrapper
    ) {
      [
        250,
        600,
        1000,
        1600,
        2500,
        4000
      ].forEach(function (delay) {
        window.setTimeout(
          function () {
            syncWishlistState(
              wrapper
            );
          },
          delay
        );
      });
    }

    function bindWishlistState(
      wrapper
    ) {
      if (!wrapper) {
        return false;
      }

      syncWishlistState(wrapper);
      scheduleWishlistChecks(wrapper);

      if (
        wrapper.dataset
          .sgWishlistBound ===
        'true'
      ) {
        return true;
      }

      wrapper.dataset.sgWishlistBound =
        'true';

      /*
        Optimistically change the custom heart
        immediately. Later checks confirm the
        actual state reported by the app.
      */
      wrapper.addEventListener(
        'click',
        function () {
          var currentlyAdded =
            wrapper.classList.contains(
              'sg-wishlist-is-added'
            );

          applyWishlistVisualState(
            wrapper,
            !currentlyAdded
          );

          scheduleWishlistChecks(
            wrapper
          );
        }
      );

      return true;
    }

    function moveActionsIntoDeals() {
      var shareSlot =
        getShareSlot();

      if (!shareSlot) {
        return false;
      }

      var dealsHeader =
        findDealsHeader(
          shareSlot
        );

      var wishlistWrapper =
        findWishlistWrapper(
          shareSlot
        );

      if (
        !dealsHeader ||
        !wishlistWrapper
      ) {
        return false;
      }

      var actions =
        dealsHeader.querySelector(
          '.sg-deals__actions[data-actions-key="' +
            actionsKey +
            '"]'
        );

      if (!actions) {
        actions =
          document.createElement(
            'div'
          );

        actions.className =
          'sg-deals__actions';

        actions.dataset.actionsKey =
          actionsKey;

        dealsHeader.appendChild(
          actions
        );
      }

      if (
        wishlistWrapper.parentNode !==
        actions
      ) {
        actions.appendChild(
          wishlistWrapper
        );
      }

      if (
        shareSlot.parentNode !==
        actions
      ) {
        actions.appendChild(
          shareSlot
        );
      }

      bindWishlistState(
        wishlistWrapper
      );

      return true;
    }

    function initialiseActions() {
      bindShareButton();

      var attemptIndex = 0;

      function attempt() {
        bindShareButton();

        if (
          moveActionsIntoDeals()
        ) {
          return;
        }

        attemptIndex += 1;

        if (
          attemptIndex >=
          retryDelays.length
        ) {
          return;
        }

        var previousDelay =
          retryDelays[
            attemptIndex - 1
          ];

        var nextDelay =
          retryDelays[
            attemptIndex
          ];

        window.setTimeout(
          attempt,
          nextDelay - previousDelay
        );
      }

      attempt();
    }

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        initialiseActions,
        { once: true }
      );
    } else {
      initialiseActions();
    }

    document.addEventListener(
      'shopify:section:load',
      initialiseActions
    );
  })();

  (function () {
  if (window.sgProductImageRibbonLoaded) return;
  window.sgProductImageRibbonLoaded = true;

    var retryTimer = null;
    var retryCount = 0;
    var maximumRetries = 10;

    function findProductImageAnchor() {
      var productMedia = document.querySelector(
        '[data-testid="product-information-media"]'
      );

      if (!productMedia) {
        return null;
      }

      var productImage = productMedia.querySelector(
        [
          '.product__media img',
          '.product-media img',
          '.product-media-container img',
          '[data-media-id] img',
          '[data-product-media-id] img',
          'img'
        ].join(',')
      );

      if (!productImage) {
        return null;
      }

      var imageAnchor = productImage.closest(
        [
          '.product__media',
          '.media',
          '.product-media',
          '[data-media-id]',
          '[data-product-media-id]',
          '.product-media-container',
          '.product__media-item'
        ].join(',')
      );

      return imageAnchor || productImage.parentElement;
    }

    function mountSperkyRibbon() {
      var ribbon =
  document.querySelector(
    '.sg-pdp-image-ribbon'
  );
      var imageAnchor = findProductImageAnchor();

      if (!ribbon || !imageAnchor) {
        return false;
      }

      var originalBlock = ribbon.closest(
        '.shopify-block'
      );

      imageAnchor.classList.add(
        'sg-pdp-ribbon-anchor'
      );

      if (ribbon.parentElement !== imageAnchor) {
        imageAnchor.appendChild(ribbon);
      }

      ribbon.hidden = false;

      /*
        Hide only the empty Custom Liquid block
        after moving the badge.
      */
      if (
        originalBlock &&
        !originalBlock.contains(imageAnchor)
      ) {
        originalBlock.style.display = 'none';
      }

      return true;
    }

    /*
      A finite retry replaces MutationObserver.
      It stops completely once mounted or after
      ten attempts.
    */
    function initialiseSperkyRibbon() {
      window.clearTimeout(retryTimer);

      retryCount = 0;

      function attemptMount() {
        if (mountSperkyRibbon()) {
          return;
        }

        retryCount += 1;

        if (retryCount < maximumRetries) {
          retryTimer = window.setTimeout(
            attemptMount,
            150
          );
        }
      }

      attemptMount();
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initialiseSperkyRibbon,
        { once: true }
      );
    } else {
      initialiseSperkyRibbon();
    }

    /*
      Needed only when Shopify reloads the section
      inside the theme editor.
    */
    document.addEventListener(
      'shopify:section:load',
      initialiseSperkyRibbon
    );
  })();